export enum EventType {
  STARTER_CLICK = 'starter.click',
  CAREER_ADVISOR_REFERRAL = 'career-advisor-referral',
}
